













export default {
  name: 'AppPicture',
  props: {
    ratio: { type: String, default: 'auto' },
    fitMode: { type: String, default: 'cover' },
    image: { type: String, default: '' },
    alt: { type: String, default: 'Изображение без названия' },
    isShowOnerrorImg: { type: Boolean, default: false },
    imageHeight: { type: String, default: '100%' },
    imageWidth: { type: String, default: '100%' },
    borderRadius: { type: String, default: '0' },
    backgroundColor: { type: String, default: '#efefef' },
    placeholderImage: { type: String, default: null },
  },
  data() {
    return {
      srcImg: this.image,
    };
  },
  mounted() {
    if (!this.image) {
      this.srcImg = this.onErrImage;
    }
  },
  computed: {
    onErrImage() {
      try {
        return this.placeholderImage
          ? this.placeholderImage
          : require('./assets/img_not_available.jpg');
      } catch (error) {
        console.error('Ошибка загрузки изображения:', error);
        return require('./assets/img_not_available.jpg');
      }
    },
    rootStyle() {
      return {
        '--fit-mode': this.fitMode,
        '--ratio': this.ratio,
        '--picture-border-radius': this.borderRadius,
        '--picture-background-color': this.backgroundColor,
      };
    },
  },
  methods: {
    async setErrImg() {
      try {
        this.srcImg = this.onErrImage;
      } catch (error) {
        console.error('Ошибка загрузки изображения:', error);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppPicture/AppPicture.vue